import { render, staticRenderFns } from "./scrollToTop.vue?vue&type=template&id=777d601b&scoped=true&"
import script from "./scrollToTop.vue?vue&type=script&lang=js&"
export * from "./scrollToTop.vue?vue&type=script&lang=js&"
import style0 from "./scrollToTop.vue?vue&type=style&index=0&id=777d601b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777d601b",
  null
  
)

export default component.exports